import { render, staticRenderFns } from "./projectIntroduction.vue?vue&type=template&id=86c6643c&"
import script from "./projectIntroduction.vue?vue&type=script&lang=js&"
export * from "./projectIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./projectIntroduction.vue?vue&type=style&index=0&id=86c6643c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports